// extracted by mini-css-extract-plugin
export var noResults = "styles-module__noResults___r2zhI";